(function () {
  const calendars = document.querySelectorAll("[data-sjv-calendar]");
  if (!calendars.length) return;

  const statusLabels = {
    open: "Ouvert 10h-18h",
    holiday: "Férié ouvert 10h-18h",
    "no-meal": "Ouvert 10h-18h, restaurant fermé",
    closed: "Fermé",
    school: "Fermé, groupes scolaires uniquement",
    office: "Parc fermé, bureau ouvert",
  };

  const monthNames = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  const availableMonths = [2, 3, 4, 5, 6, 7, 8, 9];
  const today = new Date();

  const calendarStatuses = {
    "2026-03-21": "no-meal", "2026-03-22": "open", "2026-03-24": "no-meal", "2026-03-25": "no-meal", "2026-03-26": "no-meal", "2026-03-28": "open", "2026-03-29": "open", "2026-03-31": "no-meal",
    "2026-04-01": "no-meal", "2026-04-02": "no-meal", "2026-04-04": "open", "2026-04-05": "holiday", "2026-04-06": "holiday", "2026-04-07": "open", "2026-04-08": "open", "2026-04-09": "open", "2026-04-11": "open", "2026-04-12": "open", "2026-04-13": "no-meal", "2026-04-14": "open", "2026-04-15": "open", "2026-04-16": "open", "2026-04-18": "open", "2026-04-19": "open", "2026-04-20": "no-meal", "2026-04-21": "open", "2026-04-22": "open", "2026-04-23": "open", "2026-04-25": "open", "2026-04-26": "open", "2026-04-27": "no-meal", "2026-04-28": "open", "2026-04-29": "open", "2026-04-30": "open",
    "2026-05-01": "holiday", "2026-05-02": "open", "2026-05-03": "open", "2026-05-04": "no-meal", "2026-05-05": "open", "2026-05-06": "open", "2026-05-07": "open", "2026-05-08": "holiday", "2026-05-09": "open", "2026-05-10": "open", "2026-05-11": "no-meal", "2026-05-12": "open", "2026-05-13": "open", "2026-05-14": "holiday", "2026-05-15": "open", "2026-05-16": "open", "2026-05-17": "open", "2026-05-18": "no-meal", "2026-05-19": "open", "2026-05-20": "open", "2026-05-21": "open", "2026-05-23": "open", "2026-05-24": "holiday", "2026-05-25": "holiday", "2026-05-26": "open", "2026-05-27": "open", "2026-05-28": "open", "2026-05-30": "open", "2026-05-31": "open",
    "2026-06-01": "school", "2026-06-02": "open", "2026-06-03": "open", "2026-06-04": "open", "2026-06-05": "school", "2026-06-06": "open", "2026-06-07": "open", "2026-06-08": "school", "2026-06-09": "open", "2026-06-10": "open", "2026-06-11": "open", "2026-06-12": "school", "2026-06-13": "open", "2026-06-14": "open", "2026-06-15": "school", "2026-06-16": "open", "2026-06-17": "open", "2026-06-18": "open", "2026-06-19": "school", "2026-06-20": "open", "2026-06-21": "open", "2026-06-22": "school", "2026-06-23": "open", "2026-06-24": "open", "2026-06-25": "open", "2026-06-26": "school", "2026-06-27": "open", "2026-06-28": "open", "2026-06-29": "school", "2026-06-30": "open",
    "2026-07-01": "open", "2026-07-02": "open", "2026-07-04": "open", "2026-07-05": "open", "2026-07-06": "no-meal", "2026-07-07": "open", "2026-07-08": "open", "2026-07-09": "open", "2026-07-11": "open", "2026-07-12": "open", "2026-07-13": "no-meal", "2026-07-14": "holiday", "2026-07-15": "open", "2026-07-16": "open", "2026-07-18": "open", "2026-07-19": "open", "2026-07-20": "no-meal", "2026-07-21": "open", "2026-07-22": "open", "2026-07-23": "open", "2026-07-25": "open", "2026-07-26": "open", "2026-07-27": "no-meal", "2026-07-28": "open", "2026-07-29": "open", "2026-07-30": "open",
    "2026-08-01": "open", "2026-08-02": "open", "2026-08-03": "no-meal", "2026-08-04": "open", "2026-08-05": "open", "2026-08-06": "open", "2026-08-08": "open", "2026-08-09": "open", "2026-08-10": "no-meal", "2026-08-11": "open", "2026-08-12": "open", "2026-08-13": "open", "2026-08-15": "holiday", "2026-08-16": "open", "2026-08-17": "no-meal", "2026-08-18": "open", "2026-08-19": "open", "2026-08-20": "open", "2026-08-22": "open", "2026-08-23": "open", "2026-08-24": "no-meal", "2026-08-25": "open", "2026-08-26": "open", "2026-08-27": "open", "2026-08-29": "open", "2026-08-30": "open", "2026-08-31": "no-meal",
    "2026-09-01": "open", "2026-09-02": "open", "2026-09-03": "open", "2026-09-05": "open", "2026-09-06": "open", "2026-09-07": "no-meal", "2026-09-08": "open", "2026-09-09": "open", "2026-09-10": "open", "2026-09-12": "open", "2026-09-13": "open", "2026-09-14": "no-meal", "2026-09-15": "open", "2026-09-16": "open", "2026-09-17": "open", "2026-09-19": "open", "2026-09-20": "open", "2026-09-21": "no-meal", "2026-09-22": "open", "2026-09-23": "open", "2026-09-24": "open", "2026-09-26": "open", "2026-09-27": "open", "2026-09-28": "no-meal", "2026-09-29": "open", "2026-09-30": "open",
    "2026-10-01": "open", "2026-10-03": "open", "2026-10-04": "open", "2026-10-05": "no-meal", "2026-10-06": "no-meal", "2026-10-07": "no-meal", "2026-10-08": "open", "2026-10-10": "open", "2026-10-11": "open", "2026-10-12": "office",
  };

  function isoDate(year, month, day) {
    return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }

  calendars.forEach((calendar) => {
    let shownMonth =
      today.getFullYear() === 2026 && availableMonths.includes(today.getMonth())
        ? today.getMonth()
        : 3;

    const daysTarget = calendar.querySelector("[data-sjv-calendar-days]");
    const labelTarget = calendar.querySelector("[data-sjv-calendar-label]");
    const todayTarget = calendar.querySelector("[data-sjv-calendar-today]");
    const prev = calendar.querySelector("[data-sjv-calendar-prev]");
    const next = calendar.querySelector("[data-sjv-calendar-next]");

    function renderCalendar() {
      if (!daysTarget || !labelTarget) return;

      const year = 2026;
      const firstDay = new Date(year, shownMonth, 1);
      const daysInMonth = new Date(year, shownMonth + 1, 0).getDate();
      const offset = (firstDay.getDay() + 6) % 7;
      daysTarget.innerHTML = "";
      labelTarget.textContent = `${monthNames[shownMonth]} 2026`;

      for (let i = 0; i < offset; i += 1) {
        daysTarget.appendChild(document.createElement("span"));
      }

      for (let day = 1; day <= daysInMonth; day += 1) {
        const key = isoDate(year, shownMonth, day);
        let status = calendarStatuses[key] || "closed";
        if (shownMonth === 9 && day >= 12) status = day === 12 ? "office" : "closed";

        const date = new Date(year, shownMonth, day);
        const isToday = date.toDateString() === today.toDateString();
        const button = document.createElement("button");
        button.type = "button";
        button.className = `sjv-calendar-day status-${status}${isToday ? " is-today" : ""}`;
        button.innerHTML = `<span>${day}</span><small>${statusLabels[status]}</small>`;
        button.setAttribute("aria-label", `${day} ${monthNames[shownMonth]} 2026 - ${statusLabels[status]}`);
        daysTarget.appendChild(button);
      }

      if (todayTarget) {
        const todayKey = isoDate(2026, shownMonth, today.getDate());
        const todayStatus =
          today.getFullYear() === 2026 && today.getMonth() === shownMonth
            ? calendarStatuses[todayKey] || "closed"
            : null;
        todayTarget.textContent = todayStatus ? statusLabels[todayStatus] : "Consultez le mois affiché";
      }
    }

    prev?.addEventListener("click", () => {
      const index = availableMonths.indexOf(shownMonth);
      shownMonth = availableMonths[Math.max(0, index - 1)];
      renderCalendar();
    });

    next?.addEventListener("click", () => {
      const index = availableMonths.indexOf(shownMonth);
      shownMonth = availableMonths[Math.min(availableMonths.length - 1, index + 1)];
      renderCalendar();
    });

    renderCalendar();
  });
})();
